<template>
  <div id="nav">

    <div class="item">
      Candidato
    </div>
    <div class="item">
      <a :href="apiUrl" target="_blank">Versão: {{ version }}</a>
    </div>

  </div>
</template>
<style lang="scss">
#nav {
  background-color: #fa4616;
  height: 40px;
  text-align: left;
  color: white;
  padding: 10px 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  a{
    color: white;
    text-decoration: none;
  }

}
</style>
<script>
import pkg from '../../../package.json'
export default {
  data() {
    return {
      version: pkg.version,
      apiUrl: process.env.VUE_APP_API_URL
    }
  },
  created() {
    console.log(this.apiUrl);
  }
}
</script>